module.exports = __webpack_public_path__ + "static/media/swimmer.29bbfe98.svg";